import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// (2026-07-05) Banner de aviso de vencimiento de contraseña.
// Aplica solo a operador/operador_admin (el backend ya decide vía
// password_policy: `aplica`/`avisar`/`vencida`/`dias_para_vencer`). Se muestra
// durante los últimos N días (avisar=true, no vencida) con el conteo de días.
// Descartable por sesión: la marca vive en sessionStorage (persiste al navegar)
// y AuthContext.login la limpia en cada ingreso -> reaparece al volver a entrar.
export default function PasswordExpiryBanner() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("pwd_banner_dismissed") === "1"
  );

  const pol = user && user.password_policy;
  if (!pol || !pol.avisar || pol.vencida || dismissed) return null;

  const dias = pol.dias_para_vencer;
  const txtDias = dias === 1 ? "1 día" : `${dias} días`;

  const dismiss = () => {
    sessionStorage.setItem("pwd_banner_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      role="alert"
      style={{
        backgroundColor: "#B45309",
        color: "#ffffff",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "14px",
        fontSize: "14px",
        flexWrap: "wrap",
      }}
    >
      <span>
        ⚠️ Tu contraseña vence en <strong>{txtDias}</strong>. Cámbiala para no
        perder el acceso.
      </span>
      <button
        type="button"
        onClick={() => navigate("/profile?forceChangePassword=true")}
        style={{
          backgroundColor: "#ffffff",
          color: "#B45309",
          border: "none",
          borderRadius: "4px",
          padding: "4px 12px",
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Cambiar ahora
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Cerrar aviso"
        title="Cerrar por esta sesión"
        style={{
          background: "transparent",
          color: "#ffffff",
          border: "none",
          fontSize: "18px",
          lineHeight: 1,
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>
  );
}
